/**
 * 腾讯云监控接口
 */
import $http from '../utils/http';

const tencentMonitor = {
  // 腾讯云专用时间范围
  queryTimeHorizon() {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/queryTimeHorizon`);
  },
  // CVM 云服务器监控
  queryCvmMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/cvm/query`, params);
  },
  // 云数据库 MySQL 监控
  queryCdbMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/cdb/query`, params);
  },
  // 云数据库 PostgreSQL 监控
  queryPostgresMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/postgres/query`, params);
  },
  // 云数据库 Redis 监控
  queryRedisMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/redis/query`, params);
  },
  // 云硬盘 CBS 监控
  queryCbsMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/cbs/query`, params);
  },
  // 负载均衡 CLB 监控
  queryClbMonitor(params) {
    return $http.post(`${global.API_URL}/sme/tencentMonitor/clb/query`, params);
  }
};

export default tencentMonitor;



// WEBPACK FOOTER //
// ./src/api/tencentMonitor.js